module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "select-container"
  }, [_c('div', {
    staticClass: "select-tags",
    class: {
      'error': !!_vm.isValid || _vm.inputUnvalid
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onClick($event)
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.unvalidMsg),
      expression: "unvalidMsg"
    }],
    staticClass: "placeholder error"
  }, [_vm._v(_vm._s(_vm.unvalidMsg))]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.placeholderShow),
      expression: "placeholderShow"
    }],
    staticClass: "placeholder"
  }, [_vm._v(_vm._s(_vm.placeholder))]), _vm._l((_vm.tags), function(tag, index) {
    return _c('span', {
      staticClass: "tag-item",
      class: {
        'tag-padding': _vm.disabled
      }
    }, [_vm._v(_vm._s(tag.label)), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.disabled),
        expression: "!disabled"
      }],
      staticClass: "fa fa-times",
      on: {
        "click": function($event) {
          _vm.removeTag(index)
        }
      }
    })])
  }), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSearched && _vm.droplistShow && _vm.tags.length < _vm.maxlength),
      expression: "isSearched && droplistShow && tags.length < maxlength"
    }, {
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.searchValue),
      expression: "searchValue",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm._s(_vm.searchValue)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.searchValue = $event.target.value.trim()
      }, function($event) {
        _vm.inputUnvalid = false
      }],
      "keyup": function($event) {
        if (_vm._k($event.keyCode, "enter", 13)) { return; }
        $event.stopPropagation();
        $event.preventDefault();
        _vm.addInputTag($event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })], 2), _c('span', {
    staticClass: "select-dropdown-list"
  }, [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.droplistShow),
      expression: "droplistShow"
    }],
    staticClass: "select-droplist",
    on: {
      "mousewheel": function($event) {
        _vm.onMousewheel($event)
      }
    }
  }, [_c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.optionList.length == 0),
      expression: "optionList.length == 0"
    }],
    staticClass: "select-droplist-item"
  }, [_vm._v(" 暂无相关数据")]), _vm._l((_vm.optionList), function(item, index) {
    return _c('li', {
      staticClass: "select-droplist-item",
      class: {
        'not-allowed': _vm.tags.length >= _vm.maxlength && !item.checked
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          _vm.updateSelectItem(item, index)
        }
      }
    }, [_c('v-checkbox', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.checked),
        expression: "item.checked"
      }],
      attrs: {
        "disabled": _vm.tags.length >= _vm.maxlength && !item.checked
      },
      domProps: {
        "value": (item.checked)
      },
      on: {
        "input": function($event) {
          item.checked = $event
        }
      },
      nativeOn: {
        "change": function($event) {
          _vm.updateSelectItem(item, index)
        }
      }
    }), _c('span', {
      staticClass: "text",
      attrs: {
        "title": item.label
      }
    }, [_vm._v(_vm._s(item.label))])], 1)
  })], 2), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.droplistShow && _vm.optionList.length >= 50),
      expression: "droplistShow && optionList.length >= 50"
    }],
    staticClass: "warning"
  }, [(this.searchValue != '') ? _c('span', {
    staticClass: "warning-search"
  }, [_vm._v("搜索结果过多，请提高搜索精度")]) : _c('span', {
    staticClass: "warning-default"
  }, [_vm._v("内容过多未全部列举，请搜索关键信息")])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7d5853c6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7d5853c6!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/mutilselect.vue
// module id = 777
// module chunks = 0